import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { BasicForm } from 'src/app/shared/basic-form';
import { getFromLocalStorage, setToLocalStorage } from 'src/app/shared/helpers';
import { PolicyObject } from 'src/app/shared/insurance.model';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss']
})
export class PersonalInfoComponent extends BasicForm implements OnInit {

  minDate: Date;
  maxDate: Date;
  age: number;

  ngOnInit(): void {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.formAlias = 'PersonalInfo';
    this.form = this.fb.group({
      name: ['', [Validators.required,  Validators.pattern('^[a-zA-Z]*$')]],
      surname: ['', [Validators.required,  Validators.pattern('^[a-zA-Z]*$')]],
      personalNumber: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.minLength(11), Validators.maxLength(11)]],
      birthDate: [null as Date, Validators.required],
    });

    this.form.get('birthDate').valueChanges.pipe(take(1)).subscribe(value => {
      if (typeof value === 'string') {
        this.form.get('birthDate').setValue(new Date(this.formData.birthDate));
      }
    });

    this.form.patchValue(this.formData);

    this.maxDate = new Date();
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);
    this.minDate = new Date();
    this.minDate.setFullYear(this.minDate.getFullYear() - 100);
  }


  onSubmit(): void {
    let dateValue = this.form.get('birthDate').value;
     if(this.policy.InsuranceType.type === 'once') {
    this.age = this.getAgeAfterTravel(dateValue, this.policy.InsurancePeriod.endDate);
    this.submitted$.next(true);
    if (this.form.valid && this.age < 70) {
      setToLocalStorage('policy', this.formAlias, this.form.value);
      this.stepService.nextStep();
    }
    }
    if(this.policy.InsuranceType.type === 'multiple') {
    const now = new Date();
    this.age = this.getAgeAfterTravel(dateValue, this.addDays(now, 365));
    console.log('age will be :' + this.age);
    this.submitted$.next(true);
    if (this.form.valid && this.age < 70) {
      setToLocalStorage('policy', this.formAlias, this.form.value);
      this.stepService.nextStep();
    }
     }
    else {
      this.submitted = true;
    }
  }


   addDays(date, days) {
    console.log('original date was' + date)
    const newDate = new Date(date.getTime() 
        + days * 24 * 60 * 60 * 1000);
        console.log('new date is' + newDate)
    return newDate;
}
}
   
